import React, {Component} from "react";
import {ASSET_BASE_URL} from "../../../../configs/website";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper";
import 'swiper/swiper.css';
import Ink from "react-ink";
import {Link} from "react-router-dom";
import DelayLink from "../../../helpers/delayLink";
import ProgressiveImage from "react-progressive-image";
import Countdown from "react-countdown";
// import $ from 'jquery';
/*import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';*/

class FeaturedItems extends Component {

	componentDidUpdate(prevProps, prevState, snapshot) {
		// React.initializeTouchEvents(true);
	}

	render() {
		const { slides, size, secondarySlider, slide_per_view, slide_gap } = this.props;


		return (



			<React.Fragment>

				<div className={"dl-card featured-item-wrapper"}>
					<h2 className="item-text mb-10 dl-header">Deal of the moment</h2>
					<Swiper
						modules={[Autoplay]}
						spaceBetween={30}
						slidesPerView={1.5}
						navigation
						autoplay={false}
						scrollbar={{ draggable: true }}
					>
						{this.props.items.map((item, key)=>(
							<SwiperSlide key={`item_${key}`}>
								<Link to={`/stores/${item.restaurant.slug}/${item.id}`}>
									<div className={"fi-slider-item"}>
										{/*<ProgressiveImage placeholder={''} src={""} />*/}

										<figure className={"image-container"} style={{
											backgroundImage: `url("${ASSET_BASE_URL}${item.image}")`
										}}></figure>
										<div className={"content-wrapper"} style={{}}>
											<div className={"count-wrapper"}>
												<span className={"count"}>{key+1}.</span>
											</div>

											<div className={"meta-wrapper"}>
												<h2 className={"name"}>{item.name}</h2>
												<span className={"subtext"}>by {item.restaurant.name}</span>
												<div>
													<span className={"old-price strike"}>₹{item.old_price}</span>
													<span className={"offer-price"}>₹{item.price}</span>
												</div>
											</div>

										</div>
										<div className={'counter'}>
											<div className={"left"}>
												<span className={"label"}>ends in</span>
												<h6 className={"countdown"}>
													<Countdown daysInHours={true} date={item.active_price_schedule ? new Date(item.active_price_schedule.to) : new Date()} />
												</h6>
											</div>
											<div className={"right"}>
												<i className={"f7-icons"}>arrow_up_right_square_fill</i>
											</div>
										</div>
										<Ink />
									</div>
								</Link>
							</SwiperSlide>

						))}

					</Swiper>
				</div>
			</React.Fragment>
		);
	}
}

export default FeaturedItems;
